import React from 'react';
import { connect } from 'react-redux';
import ClozeIncorrectFeedback from './cloze.incorrect';
import ClozeCorrectFeedback from './cloze.correct';
import { compose } from 'redux';
import FeedbackLayout from '../../utils/feedback/feedbackLayout';
const mapStateToProps = (state) => {
	const {
		rightFeedbackProps,
		answerCount,
		leftFeedbackProps,
	} = state.rootReducer.testPageDetails;

	return {
		rightFeedbackProps,
		answerCount,
		leftFeedbackProps,
	};
};

const ClozeFeedback = ({ rightFeedbackProps: { score, defaultFeedback } }) => {
	return (
		<section className="quiz-area-options">
			{score === 1 ? <ClozeCorrectFeedback /> : <ClozeIncorrectFeedback />}

			{!!defaultFeedback && (
				<div class="tutor-feedback">
					<i class="fa fa-comments-o" aria-hidden="true"></i>
					<p>
						<span>Feedback</span>
						{defaultFeedback}
					</p>
				</div>
			)}
			<input type="hidden" name="choosen-answer" className="choosen-answer" />
		</section>
	);
};
export default compose(
	FeedbackLayout,
	connect(mapStateToProps, null),
)(ClozeFeedback);
